// import node module libraries
import React, { Fragment, useState, useEffect } from 'react';
import { Alert, Col, Row, Container } from 'react-bootstrap';
import { ExclamationCircleFill, CheckCircleFill, ExclamationTriangleFill } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';
import axios from 'axios';

// import custom components
import NavbarHaeppyapp from 'layouts/marketing/navbars/NavbarHaeppyapp';

import SEO from 'components/marketing/seo/Seo';

// Import Loading Animation
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

// Import authentication components
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';

function TermsAndConditions() {
	const [TermsAndConditions, setTermsAndConditions] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [isFailed, setIsFailed] = useState(null); // State for show errors

	const authHeader = useAuthHeader();
	// fetch data from api
	const options = {
		params: {

		},
		headers: {
			Authorization: authHeader,
			Accept: 'application/json'
		}
	};

	const getData = async () => {
		setIsLoading(true);

		// Dynamische URL basierend auf der Umgebung
		const baseURL = process.env.REACT_APP_ENV === 'development'
			? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
			: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;


		await axios.get(`${baseURL}/public/terms-and-conditions?date=newest`, options)
			.then(response => {
				setTermsAndConditions( response.data.data[0] ? response.data.data[0] : [] ); // Extract the data from the response
				setIsLoading(false);
				setIsFailed(null);
			})
			.catch((error) => {
				console.log(error);
				setIsLoading(false);
				setIsFailed(error);
			})
	}

	useEffect(() => {
		getData();
	}, []);

	return (
		<Fragment>
			<SEO
				title="Allgemeine Geschäftsbedingungen – haeppy.app SaaS"
				noindex={true}
			/>
			<NavbarHaeppyapp
				transparent={false}
				center={false}
			/>
			<main>
				{/* pageheader */}
				<section className="py-10 bg-white">
					<Container>
						<Row className="justify-content-center">
							<Col lg={8} md={12} sm={12}>
								{/* text center */}
								<div className="text-center">
									<h1 className="display-3 fw-bold">Allgemeine Geschäftsbedingungen (AGB)</h1>
									<p className="lead px-8">
										Lesen Sie die nachstehenden Bedingungen in der aktuellsten Fassung, um mehr über Ihre Rechte und Pflichten als Nutzer der haeppy.app zu erfahren.
									</p>
								</div>
							</Col>
						</Row>
					</Container>
				</section>

				{/* error */}
				<section className="pb-10 bg-white">
					<Container>
						<Row className="justify-content-center">
							<Col lg={8} md={12} sm={12}>
								{/* error messages */}
								{ isFailed === null ? '' : isFailed ?
									<Alert variant="danger" className="justify-content-between d-flex">
										<div>
											<ExclamationTriangleFill size={20} className="me-1" />
										</div>
										<div className="ms-3">
											<Alert.Heading as="h4">
												{isFailed.message}
											</Alert.Heading>
											Es ist ein Fehler aufgetreten. Bitte versuche es erneut. Sollte der Fehler weiterhin erscheinen, kontaktiere den Helpdesk.
										</div>
									</Alert>
									: <Alert variant="danger" className="justify-content-between d-flex">
										<div>
											<ExclamationTriangleFill size={20} className="me-1" />
										</div>
										<div className="ms-3">
											<Alert.Heading as="h4">
												Undefined Error
											</Alert.Heading>
											Bitte kontaktiere den HelpDesk.
										</div>
									</Alert> 
								}
							</Col>
						</Row>
					</Container>
				</section>
				
				{/* content */}
				<section className="pb-10 bg-white">
					<Container>
						<Row className="justify-content-center">
							<Col lg={8} md={12} sm={12}>
								{isLoading ? (
									<Skeleton count={10} />
								) : (
									<div dangerouslySetInnerHTML={{ __html: TermsAndConditions.agb_text }} />
								)}
							</Col>
						</Row>
					</Container>
				</section>
			</main>
		</Fragment>
	);
}

export default TermsAndConditions;
